import React from 'react';
import { useRouter } from 'next/router';

import { useApp, useClient, useSearch, useSession, useStorage, useStore, useToast, useWorkspace } from 'contexts';

export const PageContext = React.createContext(null);

const PageProvider = ({ ssr, children }) => {
	const app = useApp();
	const client = useClient();
	const workspace = useWorkspace();
	const router = useRouter();
	const search = useSearch();
	const session = useSession();
	const storage = useStorage();
	const store = useStore();
	const toast = useToast();
	const contexts = { ssr, app, client, workspace, router, search, session, store, storage, toast, children };

	// Render
	return <PageContext.Provider value={contexts}>{children}</PageContext.Provider>;
};

export { PageProvider };
